import React from "react";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { useWizard } from "./WizardContext";
const WizardTopHeader = ({
  module,
  label = "Create transfer request",
  backIconClickHandler = () => {
    window.close();
  },
}) => {
  const { updateValues, next } = useWizard();

  const goBackHandler = () => {
    updateValues("selectedStudent", {});
    next(0);
    backIconClickHandler();
  };

  return (
    <div
      className="remove-container-top-space mb-4 d-flex heading-4 color-dark align-items-center justify-content-between top-header-collect-payment"
      //   style={headerStyle}
    >
      <div className="d-flex align-items-center">
        <IconButtonWrapper onClick={goBackHandler}>
          <BackIcon />
        </IconButtonWrapper>
        <div className=""> {label}</div>
      </div>
    </div>
  );
};

export default WizardTopHeader;
